import { logEvent } from 'firebase/analytics';
import { analytics } from '..';

export const logFirebaseEvent = (
  eventName:
    | 'api_error'
    | 'api_success'
    | 'navigate'
    | 'api_error_contracts'
    | 'api_error_home'
    | 'api_error_repairs_and_inquiries'
    | 'api_error_profile'
    | `ok_${string}`
    | `not_ok_${string}`,
  params?: any
): boolean => {
  try {
    const cookieConsent = localStorage.getItem('cookiefirst-consent')
    const userConsent = JSON.parse(cookieConsent || "{}")
    if(userConsent.performance || process.env.NODE_ENV === "development" || process.env.NODE_ENV === "dev" || process.env.NODE_ENV === "uat" ) {
      const sanitizedEventName = sanitizeValue(eventName);
      logEvent(analytics, sanitizedEventName, params);
    }
    return true;
  } catch (error) {
    console.error('Error logging event to Firebase:', error);
    return false;
  }
};

const sanitizeValue = (value: string) => {
  const match = value.match(/[a-zA-Z0-9]+/g);
  if (!match) {
    throw new Error('sanitizeValue no match');
  }
  const result = match
    .join('_')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toLowerCase();
  return result;
};
